import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../contexts/ContentContext";

export default function Footer() {
    const { t } = useContent();
    const year = new Date().getFullYear();

    return (
        <footer className="bg-brand-navy text-white py-12 px-4 sm:px-6 lg:px-8" data-testid="site-footer">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="font-display text-3xl">Zarautz</div>
                <div className="text-xs uppercase tracking-[0.25em] text-white/60 text-center">
                    © {year} Zarautz Taberna Vasca · {t?.footer?.rights}
                </div>
                <Link to="/admin" className="text-xs uppercase tracking-[0.25em] text-white/60 hover:text-brand-terracotta" data-testid="footer-admin-link">
                    {t?.footer?.admin || "Admin"}
                </Link>
            </div>
        </footer>
    );
}
